import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  totalInfo: {
    flexBasis: '49.4%',
    [theme.breakpoints.down(1422)]: {
      marginTop: '20px',
      flexBasis: '100%',
    },
  },
  sendGiftButtons: {
    display: 'flex',
    flex: 1,
    // margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? '0 0 0 20px' : '0 20px 0 0',
    marginRight: '20px',
    [theme.breakpoints.down(1422)]: {
      marginRight: 0,
      flexBasis: '100%',
      paddingLeft: 'unset',
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'flex-end',
      paddingTop: '20px !important',
      '& > a:last-child': {
        marginRight:  ({ direction }: LayoutDirection) => direction === 'rtl' ? 40 : 0,
      },
      '& > a:first-child': {
        marginRight:  ({ direction }: LayoutDirection) => direction === 'rtl' ? 0 : 40,
      },
    },
  },
}));
